import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';


module.exports = {
    createFetchParams: period => ({
        start_date: Math.floor(period.startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:            'reportsP200',
        endpoint:        endpoints.reportsP200.endpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        filterParamsMap: {
            startDate: 'start_date',
            endDate:   'end_date'
        },
        extraActions: [
            {
                method: 'get',
                action: 'downloadFile',
                url:    endpoints.reportsP200.instanceEndpoint
            }
        ]
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/reportsP200.js